import {
  REQUEST_GENERAL_MEDICAL_BODIES,
  RESPONSE_GENERAL_MEDICAL_BODIES,
  UPDATE_GENERAL_MEDICAL_BODIES_RESULTS,
  FAILURE_GENERAL_MEDICAL_BODIES,
} from "../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  statusCode: 0,
  results: [],
  error: false,
  isAdmin: false,
  isInitalScreen: true,
  size: 25,
  from: 0,
  activePage: 1,
  total: 0,
  country: [],
  condition: [],
  sorting: { key: "PATIENT_GROUPS_AND_MEDICAL_SOCIETIES", order: "desc" },
  sort: {
    label: "SOCIETIES AND PATIENT GROUPS NAME",
    value: "name",
  },
  keywords: [],
};

const setFetching = (state, action) => {
  let {
    country = [],
    condition = [],
    sorting = {},
    size = 25,
  } = action.payload;
  return {
    ...state,
    isFetching: true,
    isAdmin: false,
    statusCode: 0,
    results: [],
    country,
    condition,
    sorting,
    size,
    keyword: action.payload.keyword,
    isInitalScreen: false,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: {},
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let isAdmin = action.payload.isAdmin;
  let activePage = action.payload.activePage;
  let keywords = action.payload.keywords || [];
  let total = action.payload.total;
  let sort = action.payload.sort || {
    label: "NAME",
    value: "name",
  };

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    isAdmin,
    activePage,
    total,
    sort,
    keywords,
  };
};

const updateResults = (state, action) => {
  let updateInfo = action.payload.updateInfo;
  let remove = action.payload.remove;

  if (remove === true) {
    let newResults = {
      ...state.results,
    };
    delete newResults[updateInfo.id];

    return {
      ...state,
      results: newResults,
    };
  } else {
    let newResults = {
      ...state.results,
      [updateInfo.id]: updateInfo,
    };

    return {
      ...state,
      results: newResults,
    };
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GENERAL_MEDICAL_BODIES:
      return setFetching(state, action);
      break;

    case RESPONSE_GENERAL_MEDICAL_BODIES:
      return setResults(state, action);

    case FAILURE_GENERAL_MEDICAL_BODIES:
      return setFailure(state, action);

    case UPDATE_GENERAL_MEDICAL_BODIES_RESULTS:
      return updateResults(state, action);

    default:
      return state;
      break;
  }
};
